import {    postUploadDocumentsRekyc } from "../../../helpers/fakebackend_helper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const reKyc_UploadDocumentsRekycThunk = createAsyncThunk(
  "reKyc_UploadDocumentsRekycThunk",
  async ({ body, token }) => {
    try {
      const response = postUploadDocumentsRekyc(body, token);
      return response;
    } catch (error) {
      return error;
    }
  }
);
